import jwt_decode from "jwt-decode";
import { axiosClient } from "./axiosClient";
import { IBaseResponse } from "../model/response/IBaseResponse";
import { appConst } from "../AppConst";
import { MimeType } from "../types/mimeTypes";
import axios, { ResponseType } from "axios";
export const objectToQueryString = (obj: any, parentKey: any): string => {
  return Object.keys(obj)
    .map((key) => {
      const value = obj[key];
      const encodedKey = parentKey
        ? `${parentKey}.${encodeURIComponent(key)}`
        : encodeURIComponent(key);

      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        return objectToQueryString(value, encodedKey);
      }

      return `${encodedKey}=${encodeURIComponent(value)}`;
    })
    .join("&");
};
export const formatQueryString = (obj: any): string => {
  if (obj) {
    return objectToQueryString(obj, null);
  }
  return "";
};
type jwt_decodeResult = {
  exp: any;
};

export const clearAccessToken = () => {
  localStorage.removeItem("access_token");
};

export const clearRefreshToken = () => {
  localStorage.removeItem("refresh_token");
};
export const saveAccessToken = (access_token: string) => {
  localStorage.setItem("access_token", access_token);
};

export const saveRefreshToken = (refresh_token: string) => {
  localStorage.setItem("refresh_token", refresh_token);
};

let refreshTokenRequest: Promise<any> | null;
const checkIsTokenExpired = (): boolean => {
  // return true;
  try {
    const data: jwt_decodeResult = jwt_decode(localStorage.access_token);
    if (localStorage.access_token && data) {
      const exp = data.exp;
      if (parseInt(exp) > Math.floor(Date.now() / 1000)) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  } catch (error) {
    return false;
  }
};

const refreshToken = () => {
  return new Promise((resolve) => {
    setTimeout(async () => {
      try {
        // debugger
        let refreshTokenEnpoint = appConst.baseApiURL + "/user/token/refresh";
        if (appConst.OIDC_UNIT.toLowerCase() === "vnpt") {
            refreshTokenEnpoint = appConst.baseApiURL + "/user/token/refresh-vnpt";
        }
        const res: IBaseResponse = await axiosClient.post(refreshTokenEnpoint,
          {
            access_token: localStorage.access_token,
            refresh_token: localStorage.refresh_token,
          }
        );

        if (res.is_success) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      } catch (error) {
        localStorage.removeItem("access_token");
        window.location.reload();
      }
    }, 1000);
  });
};

const configIfTokenExpired = async () => {
  const isTokenExpired = checkIsTokenExpired();
  if (isTokenExpired) {
    refreshTokenRequest = refreshTokenRequest
      ? refreshTokenRequest
      : refreshToken();

    const newTokens = await refreshTokenRequest;
    refreshTokenRequest = null;
    if (!newTokens) {
      return {
        is_success: false,
        message: "Token expired.",
      };
    }
    //debugger
    const new_access_token = newTokens.access_token;
    const new_refresh_token = newTokens.refresh_token;
    saveAccessToken(new_access_token);
    saveRefreshToken(new_refresh_token);
  }
};
const apiClient = {
  get: async (path: string): Promise<IBaseResponse> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          language: localStorage.getItem("language"),
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };
      const res = await axiosClient.get<any, IBaseResponse>(url, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  post: async (
    path: string,
    data?: any,
    domain?: string
  ): Promise<IBaseResponse> => {
    const url = `${domain ? domain : appConst.baseApiURL}/${path}`;

    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.post<any, IBaseResponse>(url, data, config);
      return res;
    } catch (error: any) {
      //console.log('object', error);
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  put: async (path: string, data?: any): Promise<IBaseResponse> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.put<any, IBaseResponse>(url, data, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
    patch: async (path: string, data?: any): Promise<IBaseResponse> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.patch<any, IBaseResponse>(url, data, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  delete: async (path: string): Promise<IBaseResponse> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.delete<any, IBaseResponse>(url, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  upload: async (path: string, data?: any): Promise<IBaseResponse> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "multipart/form-data",
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.post<any, IBaseResponse>(url, data, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  
  /**
   * Download file với authentication
   * @param path - API endpoint path
   * @param data - Request data  
   * @param acceptType - MIME type mong muốn
   */
  download: async (
    path: string, 
    data?: any, 
    acceptType: MimeType | string = MimeType.OCTET_STREAM
  ) => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {

      //Option 1: Sử dụng axiosClient với interceptor
      await configIfTokenExpired();
      const config = {
        responseType: 'blob' as ResponseType, // Quan trọng: phải có responseType blob
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          'Content-Type': 'application/json',
          'Accept': acceptType,
          language: localStorage.getItem("language"),
        },
      } ;
      
      // const response = await axiosClient.post(url, data, config);
      const response = await axios.post(url, data, config);
      return { 
        is_success: true,
        data: response.data, // File data dưới dạng Blob
        headers: response.headers,
        message: 'Tải file thành công'
      };
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        return {
          is_success: false,
          data: null,
          message: "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        let errorMessage = 'Có lỗi xảy ra khi tải file';
        const status = error.response?.status;
        try {
          if (error.response?.data) {
            const responseData = error.response.data;
            
            // Nếu responseData là Blob (do responseType: 'blob')
            if (responseData instanceof Blob) {
        
              const blobSize = responseData.size;
              const contentType = error.response.headers?.['content-type'] || 
                                  error.response.headers?.['Content-Type'] || '';
        
              // Nếu là BadRequest hoặc Blob nhỏ hoặc Content-Type là text/json
              if (status === 400 || blobSize < 1024 * 1024 || 
                  contentType.includes('application/json') || 
                  contentType.includes('text/')) {
                try {
                  const blobClone = responseData.slice(0);
                  const text = await blobClone.text();
                  if (!text || text.trim() === '') {
                    errorMessage = `Lỗi xảy ra khi tải file (Status: ${status})`;
                  } else {
                    try {
                      const jsonData = JSON.parse(text);
                      errorMessage =jsonData.message; 
                    } catch {
                      errorMessage = text.trim();
                    }
                  }
                } catch (blobReadError) {
                  errorMessage = `Lỗi khi đọc phản hồi từ server (Status: ${status})`;
                }
              } else {
                errorMessage = 'File không hợp lệ hoặc có lỗi xảy ra';
              }
            }
            // Nếu responseData là string trực tiếp (không phải Blob)
            else if (typeof responseData === 'string') {
              errorMessage = responseData;
            } 
            // Nếu responseData là object
            else if (typeof responseData === 'object' && responseData !== null) {

              errorMessage = responseData.detail ||
                            responseData.message || 
                            responseData.value || 
                            responseData.title || 
                            responseData.error ||
                            errorMessage;
            }
          } else if (error.response?.message) {
            errorMessage = error.response.message;
          }
        } catch (parseError) {
          errorMessage = 'Error parsing error response:' + parseError?.toString();
        }
        
        return {
          is_success: false,
          data: null,
          message: errorMessage
        };
      }
    }
  },
};
export { apiClient };
